import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { Grid, Header, Table } from "semantic-ui-react";
import ResultItem from "./result";

const SearchResults = () => {
  const results = useSelector((state) => state.skuSearch);
  const productImage = useSelector((state) => state.productImage);

  const [data, setData] = useState([]);

  useEffect(() => {
    const sortArray = () => {
      const sorted = _.sortBy([...results], (r) => {
        return r.query.trim();
      });
      setData(sorted);
    };
    sortArray();
    return () => {
      setData([]);
    };
  }, [results]);

  return (
    <Grid padded>
      {results.length > 0 && (
        <Grid.Row>
          <Grid.Column>
            <Header as="h3">
              Your search for TPNB {results[0].tpnb} produced the following
              result:
            </Header>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Search term</Table.HeaderCell>
                  <Table.HeaderCell>Match</Table.HeaderCell>
                  <Table.HeaderCell>Total</Table.HeaderCell>
                  <Table.HeaderCell>Rank</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {_.map(data, (item) => (
                  <ResultItem
                    result={item}
                    key={item.query}
                    image={productImage}
                  />
                ))}
              </Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

export default SearchResults;
